import CityPageSEO from "@/hooks/usePageSEO";
import GainesvilleHeroSection from "./components/HeroSection";
import GainesvilleStickyNav from "./components/StickyNav";
import GainesvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import GainesvilleServicesSection from "./components/ServicesSection";
import GainesvilleLocalAreaSection from "./components/LocalAreaSection";
import GainesvilleTestimonialsSection from "./components/TestimonialsSection";
import GainesvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import GainesvilleComparisonSection from "./components/ComparisonSection";
import GainesvilleMistakesSection from "./components/MistakesSection";
import GainesvilleHowItWorksSection from "./components/HowItWorksSection";
import GainesvilleFAQSection, { faqs } from "./components/FAQSection";
import GainesvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import GainesvilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function GainesvilleGAPage() {
  return (
    <div className="font-sans">
      <CityPageSEO config={{
        cityName: "Gainesville",
        route: "/gainesville-ga",
        description: "Emergency and expedited passport services in Gainesville, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Hall County and northeast Georgia travelers near Lake Lanier. Get your emergency passport fast!",
        geoPlacename: "Gainesville, Georgia",
        geoPosition: "34.2979;-83.8241",
        keywords: "expedited passport, emergency passport, Gainesville GA passport, same day passport Gainesville GA, fast passport Georgia, Hall County passport",
        faqs,
      }} />
      <GainesvilleHeroSection />
      <GainesvilleStickyNav />
      <GainesvilleProcessingTimeSection />
      <GainesvilleServicesSection />
      <GainesvilleLocalAreaSection />
      <GainesvilleTestimonialsSection />
      <GainesvilleAcceptanceFacilitiesSection />
      <GainesvilleComparisonSection />
      <GainesvilleMistakesSection />
      <GainesvilleHowItWorksSection />
      <GainesvilleFAQSection />
      <GainesvilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/gainesville-ga" state="GA" />
      <GainesvilleFinalCTA />
    </div>
  );
}